import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Discard extends Bloc {

	constructor (src, ctx) {

		super("discard", src, ctx, true);
		this.f = (src, ins) => {
			ins[0].discard();
			return [];
		};
		this.types = [Types.card];
	}
}